var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The fill colors of this icon and all filled icons are hardcoded because:
 * - simplicty
 * - we will not need to change them
 */
export var SignOut = function (_a) {
    var props = __rest(_a, []);
    return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 24", fill: "none" }, props, { children: _jsx("path", { d: "M15.825 16.275C15.6417 16.0583 15.55 15.8123 15.55 15.537C15.55 15.2623 15.6417 15.0333 15.825 14.85L17.675 13H10.5C10.2167 13 9.97933 12.904 9.788 12.712C9.596 12.5207 9.5 12.2833 9.5 12C9.5 11.7167 9.596 11.479 9.788 11.287C9.97933 11.0957 10.2167 11 10.5 11H17.675L15.825 9.15C15.625 8.95 15.525 8.71267 15.525 8.438C15.525 8.16267 15.625 7.925 15.825 7.725C16.0083 7.525 16.2377 7.425 16.513 7.425C16.7877 7.425 17.0167 7.51667 17.2 7.7L20.8 11.3C20.9 11.4 20.971 11.5083 21.013 11.625C21.0543 11.7417 21.075 11.8667 21.075 12C21.075 12.1333 21.0543 12.2583 21.013 12.375C20.971 12.4917 20.9 12.6 20.8 12.7L17.2 16.3C16.9833 16.5167 16.746 16.6123 16.488 16.587C16.2293 16.5623 16.0083 16.4583 15.825 16.275ZM5.5 21C4.95 21 4.479 20.8043 4.087 20.413C3.69567 20.021 3.5 19.55 3.5 19V5C3.5 4.45 3.69567 3.979 4.087 3.587C4.479 3.19567 4.95 3 5.5 3H11.5C11.7833 3 12.021 3.09567 12.213 3.287C12.4043 3.479 12.5 3.71667 12.5 4C12.5 4.28333 12.4043 4.52067 12.213 4.712C12.021 4.904 11.7833 5 11.5 5H5.5V19H11.5C11.7833 19 12.021 19.096 12.213 19.288C12.4043 19.4793 12.5 19.7167 12.5 20C12.5 20.2833 12.4043 20.5207 12.213 20.712C12.021 20.904 11.7833 21 11.5 21H5.5Z", fill: "#6C7071" }) })));
};
